export default __webpack_public_path__ + "static/media/spinner.282e5197.gif";